import { assertExists } from '@blocksuite/global/utils';
import { createStore, atom } from 'jotai/vanilla';
import { getWorkspace, waitForWorkspace } from './__internal__/workspace.js';

const rootStore = createStore();
const loadedPluginNameAtom = atom([]);
const currentWorkspaceIdAtom = atom(null);
const currentPageIdAtom = atom(null);
const currentWorkspaceAtom = atom(async (get) => {
  const currentWorkspaceId = get(currentWorkspaceIdAtom);
  assertExists(currentWorkspaceId, "current workspace id");
  const workspace = getWorkspace(currentWorkspaceId);
  await waitForWorkspace(workspace);
  return workspace;
});
const currentPageAtom = atom(async (get) => {
  const currentWorkspaceId = get(currentWorkspaceIdAtom);
  assertExists(currentWorkspaceId, "current workspace id");
  const currentPageId = get(currentPageIdAtom);
  assertExists(currentPageId, "current page id");
  const workspace = getWorkspace(currentWorkspaceId);
  await waitForWorkspace(workspace);
  const page = workspace.getPage(currentPageId);
  assertExists(page);
  if (!page.loaded) {
    await page.waitForLoaded();
  }
  return page;
});
const contentLayoutBaseAtom = atom("editor");
const contentLayoutAtom = atom(
  (get) => get(contentLayoutBaseAtom),
  (_, set, layout) => {
    set(contentLayoutBaseAtom, (prev) => {
      let setV;
      if (typeof layout !== "function") {
        setV = () => layout;
      } else {
        setV = layout;
      }
      const nextValue = setV(prev);
      if (nextValue === "editor") {
        return nextValue;
      }
      if (nextValue.first !== "editor") {
        throw new Error("The first element of the layout should be editor.");
      }
      if (nextValue.splitPercentage && nextValue.splitPercentage < 70) {
        throw new Error("The split percentage should be greater than 70.");
      }
      return nextValue;
    });
  }
);

export { contentLayoutAtom, currentPageAtom, currentPageIdAtom, currentWorkspaceAtom, currentWorkspaceIdAtom, loadedPluginNameAtom, rootStore };
